import './_closest';
import './_find';
import './_matches';
import "./_NodeList.forEach";
import "./_Object.assign";
import "./_newEventPolyfill";
import "./_Node.remove";
import svg4everybody from 'svg4everybody';
import smoothscroll from 'smoothscroll-polyfill';


export default function runPolyfills() {
  smoothscroll.polyfill();
  svg4everybody();
}
